export enum ApigeeErrorMessage {
  BAD_REQUEST = 'bad request',
  BAD_CREDENTIALS = 'Invalid Credentials',
  API_KEY_INVALID = 'api key is invalid',
  ACCESS_TOKEN_EXPIRED = 'access token expired',
  ACCESS_TOKEN_INVALID = 'Invalid Access Token',
  AZURE_TOKEN_EXPIRED = 'The ID Token from Azure has expired',
  AZURE_TOKEN_INVALID = 'The ID Token from Azure is invalid',
  FORBIDDEN = 'forbidden',
  NOT_FOUND = 'not found',
  METHOD_NOT_ALLOWED = 'method not allowed',
  NOT_ACCEPTABLE = 'not acceptable',
  TOO_MANY_REQUESTS = 'rate limit has been exhausted',
  INTERNAL_SERVER_ERROR = 'internal server error',
  BAD_GATEWAY = 'bad gateway',
  SERVICE_UNAVAILABLE = 'service unavailable',
  GATEWAY_TIMEOUT = 'gateway timeout',
}

export enum ApigeeStatusCode {
    BAD_REQUEST = 400,
    UNAUTHORIZED = 401,
    FORBIDDEN = 403,
    NOT_FOUND = 404,
    METHOD_NOT_ALLOWED = 405,
    NOT_ACCEPTABLE = 406,
    TOO_MANY_REQUESTS = 429,
    INTERNAL_SERVER_ERROR = 500,
    BAD_GATEWAY = 502,
    SERVICE_UNAVAILABLE = 503,
    GATEWAY_TIMEOUT = 504
}

export enum ApigeeErrorCode {
  BAD_CREDENTIALS = '401-01',
  API_KEY_INVALID = '401-02',
  ACCESS_TOKEN_EXPIRED = '401-03',
  AZURE_TOKEN_EXPIRED = '401-04',
  AZURE_TOKEN_INVALID = '401-05',
  ACCESS_TOKEN_INVALID = '401-06'
}

export enum ApigeeErrorReason {
    BAD_REQUEST = 'Bad Request',
    UNAUTHORIZED = 'Unauthorized',
    FORBIDDEN = 'Forbidden',
    NOT_FOUND = 'Not Found',
    METHOD_NOT_ALLOWED = 'Method Not Allowed',
    NOT_ACCEPTABLE = 'Not Acceptable',
    TOO_MANY_REQUESTS = 'Too Many Requests',
    INTERNAL_SERVER_ERROR = 'Internal Server Error',
    BAD_GATEWAY = 'Bad Gateway',
    SERVICE_UNAVAILABLE = 'Service Unavailable',
    GATEWAY_TIMEOUT = 'Gateway Timeout'
}